module.exports = __webpack_public_path__ + "img/integrationsEmptyScreenImage.a1d9685c.png";